export default "__VITE_ASSET__BO571YXV__"